import { Component } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
import { DataSource } from 'src/app/shared/dataSource-config/dataSource'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { AuthService } from 'src/app/core/services/auth.service'
import { LayerSimulationWarningService } from 'src/app/shared/layers/layer-simulation-warning.service'
import { Input, OnChanges, SimpleChanges } from '@angular/core'

@Component({
  selector: 'app-customer-data',
  templateUrl: './customer-data.component.html',
  styleUrls: ['./customer-data.component.scss'],
  standalone: false,
})
export class CustomerDataComponent implements OnChanges {
  @Input() isHistoryVisible: boolean = false
  public Layers = Layers
  public DataSource = DataSource
  public isPartialDfrsVisible: boolean | undefined
  public isOnlyDfrsVisible: boolean | undefined
  public isVALayerVisible: boolean | undefined
  public isBDVLayerVisible: boolean | undefined
  public isCSLayerVisible: boolean | undefined
  public isLVLayerVisible: boolean | undefined
  public isTLLayerVisible: boolean | undefined
  public isHRLayerVisible: boolean | undefined
  public isHSLayerVisible: boolean | undefined
  public isSWLayerVisible: boolean | undefined
  public isPRLayerVisible: boolean | undefined
  public isWWDLayerVisible: boolean | undefined
  public isIORLayerVisible: boolean | undefined
  public isALLayerVisible: boolean | undefined
  public isBLLayerVisible: boolean | undefined
  public isSVLayerVisible: boolean | undefined
  public isTJTLayerVisible: boolean | undefined
  public onDestroy: boolean | undefined = false
  public Permissions = Permissions
  public isSimulationVisible: boolean | undefined

  constructor(
    private appState: AppStateService,
    private authService: AuthService,
    private simulationWarningLayerService: LayerSimulationWarningService,
  ) {
    const layers = this.appState.getState().layers
    const filter = this.appState.getState().filter

    if (layers) {
      this.isSimulationVisible =
        layers?.includes(Layers.SimWarning.name) &&
        this.authService.hasPermission(Layers.SimWarning.permissions, 'any')
      this.isVALayerVisible =
        layers?.includes(Layers.VAWarning.name) &&
        this.authService.hasPermission(Layers.VAWarning.permissions, 'any')
      this.isBDVLayerVisible =
        layers?.includes(Layers.BDVWarning.name) &&
        this.authService.hasPermission(Layers.BDVWarning.permissions, 'any')
      this.isCSLayerVisible =
        layers?.includes(Layers.CSWarning.name) &&
        this.authService.hasPermission(Layers.CSWarning.permissions, 'any')
      this.isLVLayerVisible =
        layers?.includes(Layers.LVWarning.name) &&
        this.authService.hasPermission(Layers.BDVWarning.permissions, 'any')
      this.isTLLayerVisible =
        layers?.includes(Layers.TLWarning.name) &&
        this.authService.hasPermission(Layers.TLWarning.permissions, 'any')
      this.isHRLayerVisible =
        layers?.includes(Layers.HRWarning.name) &&
        this.authService.hasPermission(Layers.HRWarning.permissions, 'any')
      this.isHSLayerVisible =
        layers?.includes(Layers.HSWarning.name) &&
        this.authService.hasPermission(Layers.HSWarning.permissions, 'any')
      this.isSWLayerVisible =
        layers?.includes(Layers.SWWarning.name) &&
        this.authService.hasPermission(Layers.SWWarning.permissions, 'any')
      this.isPRLayerVisible =
        layers?.includes(Layers.PRWarning.name) &&
        this.authService.hasPermission(Layers.PRWarning.permissions, 'any')
      this.isWWDLayerVisible =
        layers?.includes(Layers.WWDWarning.name) &&
        this.authService.hasPermission(Layers.WWDWarning.permissions, 'any')
      this.isIORLayerVisible =
        layers?.includes(Layers.IORWarning.name) &&
        this.authService.hasPermission(Layers.IORWarning.permissions, 'any')
      this.isALLayerVisible =
        layers?.includes(Layers.ALWarning.name) &&
        this.authService.hasPermission(Layers.ALWarning.permissions, 'any')
      this.isBLLayerVisible =
        layers?.includes(Layers.BLWarning.name) &&
        this.authService.hasPermission(Layers.BLWarning.permissions, 'any')
      this.isSVLayerVisible =
        layers?.includes(Layers.SVWarning.name) &&
        this.authService.hasPermission(Layers.SVWarning.permissions, 'any')
      this.isTJTLayerVisible =
        layers?.includes(Layers.TJTWarning.name) &&
        this.authService.hasPermission(Layers.TJTWarning.permissions, 'any')
    } else {
      this.isSimulationVisible = false
      this.isVALayerVisible = this.authService.hasPermission(Layers.VAWarning.permissions, 'any')
      this.isBDVLayerVisible = this.authService.hasPermission(Layers.BDVWarning.permissions, 'any')
      this.isLVLayerVisible = this.authService.hasPermission(Layers.LVWarning.permissions, 'any')
      this.isTLLayerVisible = this.authService.hasPermission(Layers.TLWarning.permissions, 'any')
      this.isHRLayerVisible = this.authService.hasPermission(Layers.HRWarning.permissions, 'any')
      this.isHSLayerVisible = this.authService.hasPermission(Layers.HSWarning.permissions, 'any')
      this.isSWLayerVisible = this.authService.hasPermission(Layers.SWWarning.permissions, 'any')
      this.isPRLayerVisible = this.authService.hasPermission(Layers.PRWarning.permissions, 'any')
      this.isWWDLayerVisible = this.authService.hasPermission(Layers.WWDWarning.permissions, 'any')
      this.isIORLayerVisible = this.authService.hasPermission(Layers.IORWarning.permissions, 'any')
      this.isALLayerVisible = this.authService.hasPermission(Layers.ALWarning.permissions, 'any')
      this.isBLLayerVisible = this.authService.hasPermission(Layers.BLWarning.permissions, 'any')
      this.isSVLayerVisible = this.authService.hasPermission(Layers.SVWarning.permissions, 'any')
      this.isTJTLayerVisible = this.authService.hasPermission(Layers.TJTWarning.permissions, 'any')
    }

    if (filter) {
      this.isOnlyDfrsVisible = filter?.includes(DataSource.DfrsData.name)
      this.isPartialDfrsVisible = filter?.includes(DataSource.RcsData.name)
    } else {
      this.isOnlyDfrsVisible = false
      this.isPartialDfrsVisible = true
    }

    this.updateQueryParameters()
    this.appState.stateChanged.pipe(takeUntilDestroyed()).subscribe(() => {})
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.SimWarning.name:
        this.isSimulationVisible = !this.isSimulationVisible
        break
      case Layers.VAWarning.name:
        this.isVALayerVisible = !this.isVALayerVisible
        break
      case Layers.BDVWarning.name:
        this.isBDVLayerVisible = !this.isBDVLayerVisible
        break
      case Layers.CSWarning.name:
        this.isCSLayerVisible = !this.isCSLayerVisible
        break
      case Layers.LVWarning.name:
        this.isLVLayerVisible = !this.isLVLayerVisible
        break
      case Layers.TLWarning.name:
        this.isTLLayerVisible = !this.isTLLayerVisible
        break
      case Layers.HRWarning.name:
        this.isHRLayerVisible = !this.isHRLayerVisible
        break
      case Layers.HSWarning.name:
        this.isHSLayerVisible = !this.isHSLayerVisible
        break
      case Layers.SWWarning.name:
        this.isSWLayerVisible = !this.isSWLayerVisible
        break
      case Layers.PRWarning.name:
        this.isPRLayerVisible = !this.isPRLayerVisible
        break
      case Layers.WWDWarning.name:
        this.isWWDLayerVisible = !this.isWWDLayerVisible
        break
      case Layers.IORWarning.name:
        this.isIORLayerVisible = !this.isIORLayerVisible
        break
      case Layers.ALWarning.name:
        this.isALLayerVisible = !this.isALLayerVisible
        break
      case Layers.BLWarning.name:
        this.isBLLayerVisible = !this.isBLLayerVisible
        break
      case Layers.SVWarning.name:
        this.isSVLayerVisible = !this.isSVLayerVisible
        break
      case Layers.TJTWarning.name:
        this.isTJTLayerVisible = !this.isTJTLayerVisible
        break
      case DataSource.DfrsData.name:
        // isOnlyDfrsVisible and isPartialDfrsVisible can not be false at the same time
        if (!this.isPartialDfrsVisible && this.isOnlyDfrsVisible) {
          break
        }
        this.isOnlyDfrsVisible = !this.isOnlyDfrsVisible
        break
      case DataSource.RcsData.name:
        // isOnlyDfrsVisible and isPartialDfrsVisible can not be false at the same time
        if (!this.isOnlyDfrsVisible && this.isPartialDfrsVisible) {
          break
        }
        this.isPartialDfrsVisible = !this.isPartialDfrsVisible
        break

      default:
        break
    }
    this.updateQueryParameters()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isHistoryVisible'] && changes['isHistoryVisible'].currentValue === true) {
      // Deactivate simulation layer when entering history mode
      if (this.isSimulationVisible) {
        this.isSimulationVisible = false
        const layers = this.appState.selectLayers()
        const updatedLayers = layers.filter((layer) => layer !== Layers.SimWarning.name)
        this.appState.setState(AppPaths.Customer, { layers: updatedLayers.toString() })
      }
    }
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !layer.includes(Layers.SimWarning.name) &&
          !layer.includes(Layers.BDVWarning.name) &&
          !layer.includes(Layers.VAWarning.name) &&
          !layer.includes(Layers.CSWarning.name) &&
          !layer.includes(Layers.TLWarning.name) &&
          !layer.includes(Layers.LVWarning.name) &&
          !layer.includes(Layers.HRWarning.name) &&
          !layer.includes(Layers.HSWarning.name) &&
          !layer.includes(Layers.SWWarning.name) &&
          !layer.includes(Layers.PRWarning.name) &&
          !layer.includes(Layers.WWDWarning.name) &&
          !layer.includes(Layers.IORWarning.name) &&
          !layer.includes(Layers.ALWarning.name) &&
          !layer.includes(Layers.BLWarning.name) &&
          !layer.includes(Layers.SVWarning.name) &&
          !layer.includes(Layers.TJTWarning.name),
      )
    const dfrsFilters = this.appState
      .selectFilter()
      .filter(
        (filter) =>
          !filter.includes(DataSource.DfrsData.name) && !filter.includes(DataSource.RcsData.name),
      )
    if (this.isOnlyDfrsVisible) {
      dfrsFilters.push(DataSource.DfrsData.name)
    }
    if (this.isPartialDfrsVisible) {
      dfrsFilters.push(DataSource.RcsData.name)
    }

    if (this.isSimulationVisible) {
      layers.push(Layers.SimWarning.name)
    }
    if (this.isVALayerVisible) {
      layers.push(Layers.VAWarning.name)
    }
    if (this.isBDVLayerVisible) {
      layers.push(Layers.BDVWarning.name)
    }
    if (this.isCSLayerVisible) {
      layers.push(Layers.CSWarning.name)
    }
    if (this.isLVLayerVisible) {
      layers.push(Layers.LVWarning.name)
    }
    if (this.isTLLayerVisible) {
      layers.push(Layers.TLWarning.name)
    }
    if (this.isHRLayerVisible) {
      layers.push(Layers.HRWarning.name)
    }
    if (this.isHSLayerVisible) {
      layers.push(Layers.HSWarning.name)
    }
    if (this.isSWLayerVisible) {
      layers.push(Layers.SWWarning.name)
    }
    if (this.isPRLayerVisible) {
      layers.push(Layers.PRWarning.name)
    }
    if (this.isWWDLayerVisible) {
      layers.push(Layers.WWDWarning.name)
    }
    if (this.isIORLayerVisible) {
      layers.push(Layers.IORWarning.name)
    }
    if (this.isALLayerVisible) {
      layers.push(Layers.ALWarning.name)
    }
    if (this.isBLLayerVisible) {
      layers.push(Layers.BLWarning.name)
    }
    if (this.isSVLayerVisible) {
      layers.push(Layers.SVWarning.name)
    }
    if (this.isTJTLayerVisible) {
      layers.push(Layers.TJTWarning.name)
    }
    this.appState.setState(AppPaths.Customer, {
      layers: layers?.toString(),
      metrics: undefined,
      filter: dfrsFilters.length > 0 ? dfrsFilters?.toString() : undefined,
    })
  }
}
